module.exports = "  <react-component name=\"RenderSocialScoreSettingsReact\" props=\"props\" watch-depth=\"reference\"/>\n"